<div class="row gx-0 mt-2">
  <div class="col d-flex align-items-end gap-2">
    <div class="text-center d-inline-block" [style.width]="DEFAULT_LOGO_CONTAINER_WIDTH">
      <app-ticket-change-history-author-logo [changeHistory]="changeHistory"/>
    </div>
    <small class="text-body-secondary">
      {{ changeHistory.system ? 'PEAK' : (changeHistory.author_full_name ? changeHistory.author_full_name : '') }} -
      <span [title]="(changeHistory.ts | timezone: site?.timezone)?.format(TIMESTAMP_FORMAT)">{{ changeHistory.ts | timezone: site?.timezone | timeAgo }}</span>
    </small>
  </div>
</div>

@for (field of changeHistory?.fields; track field.field_id) {
  <div class="row gx-0">
    <div class="col">
      <div class="text-break">
        @switch (lookupChangeField(field.field_id)) {
          @case (ChangeHistoryFieldType.CREATE_CHANGE_FIELD) {
            <span [innerHTML]="getTicketCreatedValue()"></span>
          }
          @case (ChangeHistoryFieldType.SELECT_CHANGE_FIELD) {
            <span [innerHTML]="getSelectFieldChangeValues(field)"></span>
          }
          @case (ChangeHistoryFieldType.STATUS_CHANGE_FIELD) {
            <span [innerHTML]="getStatusFieldChangeValues(field)"></span>
          }
          @case (ChangeHistoryFieldType.DATE_CHANGE_FIELD) {
            <span [innerHTML]="getDateFieldChangeValues(field)"></span>
          }
          @case (ChangeHistoryFieldType.ARCHIVED_CHANGE_FIELD) {
            <span [innerHTML]="getArchivedFieldChangeValues(field)"></span>
          }
          @case (ChangeHistoryFieldType.TEXT_CHANGE_FIELD) {
            <span>
              <span [innerHTML]="getTextFieldChangeHistoryFirstMessage(field)"></span>
              <strong>
                <app-ellipses-n-chars [text]="field.old_value?.['value'] || NO_VALUE" [textHiddenClass]="'text-nowrap'"
                                      [textUnhiddenClass]="{'text-pre': hasNewLine(field.old_value?.['value'])}"
                                      [showLessClass]="'fw-normal'"/>
              </strong>
              {{ 'Change History Text Field Second Message' | messageTranslate }}
              <strong>
                <app-ellipses-n-chars [text]="field.new_value?.['value'] || NO_VALUE" [textHiddenClass]="'text-nowrap'"
                                      [textUnhiddenClass]="{'text-pre': hasNewLine(field.new_value?.['value'])}"
                                      [showLessClass]="'fw-normal'"/>
              </strong>
            </span>
          }
          @case (ChangeHistoryFieldType.ADD_REMOVE_CHANGE_FIELD) {
            @if (field?.field_id === TicketFieldId.EQUIPMENT_IDS && equipmentLoading) {
              <ng-template [ngTemplateOutlet]="loadingReferenceBlock"
                           [ngTemplateOutletContext]="{message: {messageKey: 'Loading Equipment...'}}"/>
            } @else {
              <span [innerHTML]="getAddRemoveFieldChangeValues(field)"></span>
            }
          }
          @case (ChangeHistoryFieldType.LINK_UNLINK_CHANGE_FIELD) {
            <span [innerHTML]="getLinkUnlinkChangeHistoryValues(field)"></span>
          }
          @case (ChangeHistoryFieldType.FAULT_STATUS_CHANGE_FIELD) {
            <span [innerHTML]="getFaultStatusFieldChangeHistoryValues(field)"></span>
          }
          @case (ChangeHistoryFieldType.LAST_FAULT_CHANGE_DATE_FIELD) {
            <span [innerHTML]="getLastFaultTransitionedFieldChangeValues(field)"></span>
          }
          @case (ChangeHistoryFieldType.SAVINGS_CHANGE_FIELD) {
            <span [innerHTML]="getSavingsFieldChangeValues(field)"></span>
          }
          @case (ChangeHistoryFieldType.TIME_TAKEN_FIELD) {
            <span [innerHTML]="getTimeTakenFieldChangeValues(field)"></span>
          }
          @case (ChangeHistoryFieldType.IMPACTS_CHANGE_FIELD) {
            @if (impactsLoading) {
              <ng-template [ngTemplateOutlet]="loadingReferenceBlock"
                           [ngTemplateOutletContext]="{message: {messageKey: 'Loading Impacts...'}}"/>
            } @else {
              <span [innerHTML]="getImpactsFieldChangeValues(field)"></span>
            }
          }
          @case (ChangeHistoryFieldType.PRIORITIES_CHANGE_FIELD) {
            @if (prioritiesLoading) {
              <ng-template [ngTemplateOutlet]="loadingReferenceBlock"
                           [ngTemplateOutletContext]="{message: {messageKey: 'Loading Priorities...'}}"/>
            } @else {
              <span [innerHTML]="getSelectFieldChangeValues(field)"></span>
            }
          }
          @case (ChangeHistoryFieldType.INBOX_CHANGE_FIELD) {
            @if (!changeHistory.system) {
              <span [innerHTML]="getInboxChangeHistoryValues(field)"></span>
            }
          }
          @default {
            <span [innerHTML]="getTranslatedDefaultErrorMessage(field)"></span>
          }
        }
      </div>
    </div>
  </div>
}


<ng-template #loadingReferenceBlock let-message="message">
  <span class="text-body-secondary"><em>{{message | messageTranslate}}</em></span>
</ng-template>
